import tw, { styled } from "twin.macro"

interface InformationProps {
  label: string
  center?: boolean
}

interface StyledInformationProps {
  center?: boolean
}

const StyledInformation = styled("p")(({ center }: StyledInformationProps) => [
  tw`
    text-left
    text-sm
    font-sans
  `,
  center === true && tw`text-center`,
])

export const Information = ({ label, center }: InformationProps) => {
  const richText =
    label &&
    label.split("\n").map((str: string, i: number) => (
      <span key={i}>
        {i != 0 && <br />}
        <span>{str}</span>
      </span>
    ))

  return <StyledInformation center={center}>{richText}</StyledInformation>
}

export default Information
